// 9fbef606107a605d69c0edbcd8029e5d
import { getABtestFromState } from '@tcp/core/src/utils';

export const getStyliticsProductTabListSelector = (state) => state.StyliticsProductTabList;

export const getCTLImageABTest = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests.showSmallSizeCTLImage;
};

export default {
  getStyliticsProductTabListSelector,
  getCTLImageABTest,
};
